export default [
	// 经销商详情
    {
        path: '/personal/angentDetail',
        component: () => import( '@/views/personal/angentDetail.vue'),//
    },
    // 经销商修改
    {
        path: '/personal/updateDetail',
        component: () => import( '@/views/personal/updateDetail.vue'),//
    },
    // 总部供应商详情
    {
        path: '/personal/supplierList',
        component: () => import( '@/views/personal/supplierList.vue'),//
        meta: {
            title: '总部供应商列表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    // 上海直销供应商详情
    {
        path: '/personal/supplierShangHaiList',
        component: () => import( '@/views/personal/supplierList_shanghai.vue'),//
        meta: {
            title: '供应商列表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    // 供应商审核
    {
        path: '/personal/supplierVerity',
        component: () => import( '@/views/personal/supplierVerity.vue'),//
    },
    // 新增供应商
    {
        path: '/personal/signSupplier',
        component: () => import( '@/views/personal/signSupplier.vue'),//
    },
	// 待办中心
	{
	    path: '/personal/dealCenter',
	    component: () => import( '@/views/personal/dealCenter.vue'),//
        meta: {
            keepAlive: true,//true缓存 false不缓存
            title: '待办中心',
            isTabsPage: true
        }
    },
	// 消息中心
	{
        path: '/personal/messageCenter',
        component: () => import( '@/views/personal/messageCenter.vue'),//
        meta: {
            title: '消息中心',
            isTabsPage: true,
            keepAlive:true
        }
    },
	// 内部用户
	{
        path: '/personal/userin',
        component: () => import( '@/views/personal/userin.vue'),//
    },
    // 内部用户
    {
        path: '/personal/userinApprove',
        component: () => import( '@/views/personal/userinApprove.vue'),//
    }
]
